import styled from "styled-components";
import Button from "../common/Button";

import { useSelector } from "react-redux";

const WriteActionButtonsBlock = styled.div`
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    margin-top: 1rem;
    margin-bottom: 3rem;
    // button + button {
    //     margin-left: 0.5rem;
    // }
    padding: 2rem 1rem 0;
`;

// TagBox에서 사용하는 버튼과 일치하는 높이로 설정한 후 서로 간의 여백 지정
const StyledButton = styled(Button)`
    height: 2.125rem;
    & + & {
        margin-left: 0.5rem;
    }
`;

const WriteActionButtons = ({ onPublish, onCancel, isEdit }) => {

    // console.log('isEdit : ', isEdit);
    const language = useSelector(state => state.language.language);
    const isKR = language === 'KR' ? true : false;
    const isJP = language === 'JP' ? true : false;
    const isEN = language === 'EN' ? true : false;

    const editText = isKR ? '수정' : isJP ? '修正' : isEN ? 'Edit' : '';
    const registerTest = isKR ? '등록' : isJP ? '登録' : isEN ? 'Register' : '';

    return (
        <WriteActionButtonsBlock>
            <StyledButton cyan onClick={onPublish}>{isKR ? '프로젝트' : isJP ? 'プロジェクト' : isEN ? 'Project' : ''} {isEdit ? editText : registerTest}</StyledButton>
            <StyledButton onClick={onCancel}>{isKR ? '취소' : isJP ? 'キャンセル' : isEN ? 'Cancel' : ''}</StyledButton>
        </WriteActionButtonsBlock>
    );
};

export default WriteActionButtons;